import React from 'react';
import APPCONFIG from 'constants/Config';
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;

class Footer extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isDemoLogin: false
    }
  }
 componentDidMount(){
  const userData = ls.getUserDetails();
  if (userData.is_demo_user) {
    this.setState({
      isDemoLogin: true
    });

  } else {
    this.setState({
      isDemoLogin: false
    });
  };
 }
  render() {
    return (
      <section className="app-footer">
        <div className="container-fluid">
          <span className="float-left">
            <span>Copyright © <a className="brand" target="_blank" href={APPCONFIG.productLink}>{APPCONFIG.brand}</a> {APPCONFIG.year}</span>
          </span>
          <span className="float-right">
            <span>Built with Love <i className="material-icons">favorite_border</i></span>
          </span>
        </div>
        { this.state.isDemoLogin &&
        <div className="callout callout-warning" style={{position: "fixed", right:"0px", bottom:"0px", "max-width": "400px"}} >
          <h4>Demo Account</h4>
          <p>This is a demo account. Few device related functionalities may not work in rela time.</p>
        </div>
        }
      </section>
    );
  }
}

module.exports = Footer;



// WEBPACK FOOTER //
// ./components/Footer/index.js